var OrganizationApplications;

import UserOrganizationsContainer from '../users_organizations_container.js';

import OrganizationsTab from 'trunks/vue/admin/components/organizations/organization_tab.js';

import UserItem from 'trunks/vue/admin/components/libs/user_item.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import ApplicationItem from './organization_applications/application_item.js';

import Paginator from 'trunks/vue/admin/components/paginator.js';

import OrganizationState from 'trunks/vue/admin/components/organizations/organization_state.js';

export default OrganizationApplications = Vue.extend({
  components: {
    'user-organization-container': UserOrganizationsContainer,
    'organization-tab': OrganizationsTab,
    'application-item': ApplicationItem,
    'paginator': Paginator
  },
  props: {
    organization: {
      type: Object
    },
    organizationApplicationsCount: {
      type: Number
    }
  },
  data: function() {
    return {
      resources: `/admin/organizations/${this.organization.id}/organization_applications`,
      applicationsList: [],
      showProcessed: false,
      pendingOrganizationApplicationsCount: this.organizationApplicationsCount,
      currentPage: 1,
      organizationState: OrganizationState
    };
  },
  watch: {
    statusFilter: function() {
      return this.$nextTick(() => {
        return this.$refs.paginator.go();
      });
    },
    'organizationState.name': function() {
      return this.organization.name = this.organizationState.name;
    }
  },
  computed: {
    statusFilter: function() {
      if (this.showProcessed) {
        return {};
      } else {
        return {
          status: 'pending'
        };
      }
    },
    showPaginator: function() {
      if (this.applicationsList.length === 0 && this.currentPage === 1) {
        return false;
      } else {
        return true;
      }
    }
  },
  template: `<user-organization-container :title="organization.name">
  <template slot="content">
    <organization-tab activeTab="organization_applications"
                      :organizationId="organization.id"
                      :pendingOrganizationApplicationsCount='pendingOrganizationApplicationsCount' />
    <div class="organization-applications">
      <div class="applications-top">
        <label class="option-item">
          <input hidden="true"
                 type="checkbox"
                 v-model="showProcessed">
          <i class="slp-square-o"></i>
          <span class="option-label">显示已处理的请求</span>
        </label>
      </div>
      <div class="application-content-wrapper">
        <div class="application-no-content"
            v-if="applicationsList.length == 0">暂无申请</div>
        <div class="applications-content" v-else>
          <application-item v-for="application in applicationsList"
                            :resources="resources"
                            :organization="organization"
                            :key="application.id"
                            :application="application"
                            @statusChanged="statusChanged"/>
        </div>
        <paginator  v-show="showPaginator"
                    :resourceUrl='resources'
                    :additionalParams="statusFilter"
                    :initialPage='1'
                    @dataReceived="dataReceived"
                    ref='paginator' />
      </div>
    </div>
  </template>
</user-organization-container>`,
  mounted: function() {
    return this.$refs.paginator.go();
  },
  methods: {
    statusChanged: function(application) {
      this.pendingOrganizationApplicationsCount -= 1;
      if (!this.showProcessed) {
        this.applicationsList = _.filter(this.applicationsList, function(item) {
          return item.id === application.id;
        });
        return this.$refs.paginator.refresh();
      }
    },
    dataReceived: function(data, option) {
      this.applicationsList = data;
      return this.currentPage = option.currentPage;
    }
  }
});
